import type { FC } from "react";

import type { AtlasError } from "./AtlasError";

interface AtlasErrorInfoProps {
	error: AtlasError;
}

export const AtlasErrorInfo: FC<AtlasErrorInfoProps> = ({ error }) => {
	return (
		<div>
			<div className="my-4">
				Atlas Error ID:
				<br />
				{error.atlasErrorId}
			</div>
			{error.details && (
				<div className="mb-4">
					Details:
					<br />
					{error.details}
				</div>
			)}
			<a href={error.documentationUrl} target="_blank" rel="noreferrer">
				See the docs
			</a>
		</div>
	);
};
